import { isAvailable, Feature } from 'App/services/FeatureHelperStandalone';

const MarketingBoardAllowed = () => {
	return isAvailable(Feature.MA_DASHBOARD);
};

export default MarketingBoardAllowed;
